import api from './api';

export const reportService = {
  getBalanceEvolution: async (months = 6) => {
    return api.get('/reports/balance-evolution', { params: { months } });
  },

  getCategoryReport: async (startDate, endDate) => {
    return api.get('/reports/categories', { params: { startDate, endDate } });
  },

  getMonthlyComparison: async (months = 6) => {
    return api.get('/reports/monthly-comparison', { params: { months } });
  },

  getCashFlowProjection: async (months = 3) => {
    return api.get('/reports/cash-flow', { params: { months } });
  },

  getSummaryReport: async () => {
    return api.get('/reports/summary');
  },
};

export default reportService;
